// SEO Content: Unique, high-quality content for each location
// Each page has 800-1200 words of unique, locally-relevant content
// Structure: city -> district (optional) -> content sections

export const seoContent = {
  duesseldorf: {
    // Main city page - Düsseldorf
    main: {
      heroTitle: "Ihr Maler in Düsseldorf – Qualität & Zuverlässigkeit",
      heroSubtitle: "Professionelle Malerarbeiten für die Landeshauptstadt. Von der Altstadt bis Benrath – wir sind Ihr Partner für Innenanstrich, Fassadenarbeiten und komplette Renovierungen.",
      
      // Main content section (unique, 800-1200 words)
      mainContent: {
        intro: `Als etablierter Malerbetrieb mit jahrelanger Erfahrung in Düsseldorf verstehen wir die besonderen Anforderungen dieser vielfältigen Metropole. Ob Sie in einer denkmalgeschützten Altbauwohnung in Oberkassel wohnen, ein modernes Loft in Flingern besitzen oder ein Einfamilienhaus in Benrath Ihr Eigen nennen – wir passen unsere Arbeit individuell an Ihre Immobilie und Ihre Wünsche an.
        
Die Landeshauptstadt Nordrhein-Westfalens ist bekannt für ihre architektonische Vielfalt. Von den historischen Fassaden entlang der Königsallee über die modernen Glasfronten im Medienhafen bis zu den gemütlichen Altbauvierteln in Pempelfort – jedes Gebäude hat seinen eigenen Charakter. Unser erfahrenes Team kennt die Besonderheiten der verschiedenen Düsseldorfer Stadtteile und weiß, welche Materialien und Techniken wo am besten zum Einsatz kommen.`,
        
        localExpertise: `Als lokaler Malerbetrieb sind wir in ganz Düsseldorf zuhause. Wir kennen die strengen Auflagen für denkmalgeschützte Gebäude in Kaiserswerth ebenso wie die modernen Anforderungen an Gewerbeobjekte im Medienhafen. Diese lokale Expertise macht den Unterschied: Wir wissen, welche Genehmigungen in welchem Stadtteil erforderlich sind, kennen die örtlichen Gegebenheiten und können dadurch effizienter und kostengünstiger arbeiten.

Unsere Kunden schätzen unsere kurzen Anfahrtswege. Von unserem Standort aus erreichen wir jeden Düsseldorfer Stadtteil schnell und unkompliziert – ob Bilk, Unterbilk, Derendorf oder Gerresheim. Das bedeutet für Sie: flexible Terminvergabe, schnelle Reaktionszeiten und keine überhöhten Anfahrtskosten.`,

        services: `Unser Leistungsspektrum in Düsseldorf umfasst alle klassischen und modernen Malerarbeiten. Beim Innenanstrich verwenden wir ausschließlich hochwertige, emissionsarme Farben namhafter Hersteller wie Caparol, Brillux und Alpina. Für Allergiker und Familien mit Kindern bieten wir spezielle Öko-Farben an, die besonders schadstoffarm sind.

Im Bereich Fassadenarbeiten haben wir uns auf die besonderen Anforderungen Düsseldorfer Immobilien spezialisiert. Die Nähe zum Rhein und das feuchte Klima stellen hohe Ansprüche an Fassadenfarben und -putze. Wir setzen auf witterungsbeständige Systeme, die Ihre Fassade langfristig schützen und gleichzeitig atmungsaktiv bleiben – wichtig gerade bei den vielen Altbauten in Düsseldorf.

Besonders gefragt sind unsere Tapezierarbeiten. Ob klassische Raufaser, moderne Vliestapeten oder exklusive Designertapeten – wir verarbeiten alle Tapetenarten professionell und sauber. In den großzügigen Altbauwohnungen Düsseldorfs mit ihren hohen Decken ist Erfahrung gefragt, die wir über viele Jahre gesammelt haben.`,

        process: `Unser Arbeitsprozess beginnt immer mit einer persönlichen Beratung vor Ort. Bei diesem kostenlosen Besichtigungstermin nehmen wir Ihre Wünsche auf, begutachten die baulichen Gegebenheiten und erstellen anschließend ein detailliertes Angebot. Dabei berücksichtigen wir auch versteckte Kosten wie die Vorbereitung des Untergrunds oder notwendige Ausbesserungsarbeiten – so erleben Sie keine bösen Überraschungen.

Nach Auftragserteilung vereinbaren wir einen verbindlichen Starttermin. Wir arbeiten zügig, aber gründlich und achten penibel auf Sauberkeit. Möbel und Böden werden sorgfältig abgedeckt, Steckdosen und Lichtschalter fachgerecht abgeklebt. Nach Abschluss der Arbeiten hinterlassen wir Ihre Räume besenrein.`,

        whyUs: `Was uns von anderen Malerbetrieben in Düsseldorf unterscheidet? Zunächst unsere Transparenz: Wir arbeiten mit Festpreisen und detaillierten Angeboten. Was im Kostenvoranschlag steht, gilt – ohne Nachforderungen. Zweitens unsere Qualitätsgarantie: Wir arbeiten so lange, bis Sie vollständig zufrieden sind. Und drittens unsere Flexibilität: Auch kurzfristige Termine sind bei uns möglich, und bei Bedarf arbeiten wir auch außerhalb der üblichen Geschäftszeiten.

Unsere Mitarbeiter sind ausgebildete Maler und Lackierer mit langjähriger Berufserfahrung. Regelmäßige Schulungen sorgen dafür, dass wir immer auf dem neuesten Stand der Technik sind – sei es bei innovativen Farbsystemen, effizienten Arbeitstechniken oder ökologisch nachhaltigen Materialien.`
      },
      
      // Service highlights for this location
      serviceHighlights: [
        {
          title: "Innenanstrich Düsseldorf",
          description: "Professionelles Streichen von Wänden und Decken in allen Düsseldorfer Stadtteilen. Hochwertige Farben, saubere Arbeit, faire Preise.",
          link: "/innenanstrich-duesseldorf"
        },
        {
          title: "Fassadenanstrich Düsseldorf",
          description: "Witterungsbeständiger Schutz für Ihre Hausfassade. Speziell für das Düsseldorfer Klima optimiert.",
          link: "/fassadenarbeiten-duesseldorf"
        },
        {
          title: "Wohnungsrenovierung Düsseldorf",
          description: "Komplettrenovierung aus einer Hand. Ideal für Altbauwohnungen in Pempelfort, Bilk oder Flingern.",
          link: "/renovierung-duesseldorf"
        },
        {
          title: "Tapezierarbeiten Düsseldorf",
          description: "Von Raufaser bis Designertapete – professionelles Tapezieren auch in hohen Altbauräumen.",
          link: "/tapezierarbeiten-duesseldorf"
        },
        {
          title: "Express-Maler Düsseldorf",
          description: "Schnelle Hilfe bei Umzug oder Wohnungsübergabe. Kurzfristige Termine verfügbar.",
          link: "/wohnungsuebergabe-duesseldorf"
        },
        {
          title: "Lackierarbeiten Düsseldorf",
          description: "Türen, Fenster, Heizkörper – wir lackieren präzise und sauber für ein perfektes Finish.",
          link: "/lackierarbeiten-duesseldorf"
        }
      ],
      
      // FAQ specific to this location
      faq: [
        {
          question: "Was kostet ein Maler in Düsseldorf pro Quadratmeter?",
          answer: "Die Kosten variieren je nach Leistung und Aufwand. Für einen einfachen Innenanstrich mit Dispersionsfarbe rechnen Sie mit ca. 8-15€ pro m² inklusive Material. Komplexere Arbeiten wie Tapezieren oder Spachteln liegen entsprechend höher. Wir erstellen Ihnen gerne ein kostenloses Angebot nach einer Vor-Ort-Besichtigung."
        },
        {
          question: "Wie schnell können Sie in Düsseldorf einen Termin anbieten?",
          answer: "In der Regel können wir innerhalb von 1-2 Wochen mit den Arbeiten beginnen. Für dringende Projekte wie Wohnungsübergaben bieten wir einen Express-Service an – oft sind dann auch kurzfristigere Termine innerhalb weniger Tage möglich."
        },
        {
          question: "Arbeiten Sie in allen Düsseldorfer Stadtteilen?",
          answer: "Ja, wir sind in ganz Düsseldorf tätig – von Kaiserswerth im Norden bis Benrath im Süden, von Oberkassel im Westen bis Gerresheim im Osten. Jeder Stadtteil ist für uns gut erreichbar."
        },
        {
          question: "Bieten Sie auch Arbeiten an denkmalgeschützten Gebäuden in Düsseldorf an?",
          answer: "Ja, wir haben Erfahrung mit denkmalgeschützten Objekten, wie sie beispielsweise in Kaiserswerth, der Altstadt oder Oberkassel vorkommen. Wir kennen die besonderen Anforderungen und arbeiten bei Bedarf mit den zuständigen Behörden zusammen."
        },
        {
          question: "Welche Garantie geben Sie auf Ihre Malerarbeiten?",
          answer: "Wir geben auf alle unsere Arbeiten eine Gewährleistung gemäß gesetzlicher Vorgaben. Darüber hinaus ist es unser Anspruch, dass Sie vollständig zufrieden sind. Sollten Sie nach Abschluss der Arbeiten Mängel feststellen, beheben wir diese umgehend und kostenfrei."
        }
      ],
      
      // Nearby districts to link to
      nearbyAreas: [
        { name: "Bilk", slug: "bilk" },
        { name: "Pempelfort", slug: "pempelfort" },
        { name: "Flingern", slug: "flingern-nord" },
        { name: "Oberkassel", slug: "oberkassel" },
        { name: "Derendorf", slug: "derendorf" },
        { name: "Unterbilk", slug: "unterbilk" }
      ],
      
      // Meta information
      meta: {
        title: "Maler Düsseldorf | Malerarbeiten & Renovierung | FarbWelt Service",
        description: "Professioneller Maler in Düsseldorf ✓ Innenanstrich ✓ Fassadenarbeiten ✓ Tapezieren ✓ Wohnungsrenovierung. Kostenlose Beratung & faire Festpreise. Jetzt Termin buchen!",
        keywords: "Maler Düsseldorf, Malerbetrieb Düsseldorf, Malerarbeiten Düsseldorf, Wohnung streichen Düsseldorf, Renovierung Düsseldorf, Anstreicher Düsseldorf"
      }
    },
    
    // District: Bilk
    bilk: {
      heroTitle: "Maler in Düsseldorf-Bilk – Ihr lokaler Fachbetrieb",
      heroSubtitle: "Professionelle Malerarbeiten im beliebten Bilker Viertel. Altbausanierung, Wohnungsrenovierung und mehr – direkt vor Ihrer Haustür.",
      
      mainContent: {
        intro: `Bilk gehört zu den beliebtesten und lebendigsten Stadtteilen Düsseldorfs. Das Viertel südlich der Innenstadt besticht durch seinen einzigartigen Mix aus gründerzeitlicher Architektur, studentischem Flair und multikultureller Vielfalt. Die Nähe zur Heinrich-Heine-Universität und den Rheinwiesen macht Bilk zu einem begehrten Wohnort für junge Familien, Studierende und Berufstätige gleichermaßen.

Als Malerbetrieb mit umfassender Erfahrung in Düsseldorf-Bilk kennen wir die architektonischen Besonderheiten dieses Viertels genau. Die charakteristischen Altbauten mit ihren hohen Stuckdecken, Holzdielen und großzügigen Räumen erfordern besonderes handwerkliches Geschick. Viele dieser Gebäude stehen unter Denkmalschutz oder in Erhaltungssatzungen – hier ist Erfahrung und Fingerspitzengefühl gefragt, das wir über Jahre aufgebaut haben.`,

        localExpertise: `Bilk ist unser Stammviertel. Wir haben hier bereits zahlreiche Projekte erfolgreich umgesetzt – von der Komplettrenovierung einer 150-m²-Altbauwohnung in der Aachener Straße bis zur Fassadensanierung eines Mehrfamilienhauses am Bilker Bahnhof. Diese lokale Verwurzelung bringt handfeste Vorteile: Kurze Wege, schnelle Verfügbarkeit und ein tiefes Verständnis für die spezifischen Anforderungen Bilker Immobilien.

Die Florastraße, die Herzogstraße und die Brunnenstraße – wir kennen die Straßenzüge und ihre architektonischen Eigenheiten. Wir wissen, welche Farbsysteme sich in den sonnenarmen Hinterhöfen bewähren und welche Tapeten in den großen, hellen Altbauwohnungen zur Geltung kommen. Dieses Detailwissen macht den Unterschied zwischen einer durchschnittlichen und einer herausragenden Malerarbeit.`,

        services: `Unser Serviceangebot in Bilk ist auf die Bedürfnisse der Bewohner zugeschnitten. Der Innenanstrich in Altbauwohnungen gehört zu unseren Kernkompetenzen. Die hohen Decken von oft über 3,50 Metern erfordern spezielle Arbeitstechniken und Gerüstsysteme. Wir arbeiten effizient und sicher, auch in schwierigen Raumhöhen.

Besonders nachgefragt in Bilk: unsere Renovierungsservices für Mietwohnungen. Ob Einzug in eine neue Wohnung oder Übergabe an den Vermieter – wir sorgen für ein einwandfreies Ergebnis. Dabei übernehmen wir nicht nur das Streichen, sondern bei Bedarf auch kleinere Reparaturarbeiten wie das Verspachteln von Dübellöchern oder das Ausbessern kleiner Wandschäden.

Die Fassadenarbeiten in Bilk verlangen besondere Sorgfalt. Viele Altbauten verfügen über aufwendige Stuckverzierungen und Ornamente, die fachgerecht behandelt werden müssen. Wir arbeiten mit speziellen Mineralfarben, die den historischen Charakter erhalten und gleichzeitig modern schützen.`,

        process: `Für Bilker Kunden beginnt jedes Projekt mit einer persönlichen Beratung – entweder bei Ihnen vor Ort oder in einem kurzen Telefongespräch. Bei größeren Vorhaben empfehlen wir immer eine Vor-Ort-Besichtigung, um den Zustand der Räume oder der Fassade genau einschätzen zu können. Gerade in Altbauten verbergen sich manchmal Überraschungen unter alten Tapetenschichten, die wir vorab identifizieren sollten.

Nach der Bestandsaufnahme erhalten Sie ein detailliertes Festpreisangebot. Wir listen alle Einzelleistungen transparent auf – so wissen Sie genau, wofür Sie bezahlen. Zusatzkosten gibt es bei uns nicht. Sollte sich während der Arbeiten Unvorhergesehenes zeigen, sprechen wir das vorher mit Ihnen ab.

Die Terminplanung erfolgt flexibel nach Ihren Wünschen. Da wir in Bilk ansässig sind, können wir auch Termine am frühen Morgen oder späten Nachmittag anbieten – ideal für Berufstätige, die nicht den ganzen Tag zuhause sein können.`,

        whyUs: `Warum FarbWelt für Ihr Projekt in Bilk? Zunächst einmal unsere Erfahrung: Wir haben in Bilk bereits Dutzende Projekte realisiert und kennen das Viertel wie unsere Westentasche. Zweitens unsere Qualität: Wir verwenden nur hochwertige Materialien und arbeiten nach den neuesten Standards. Drittens unser Service: Flexible Terminvergabe, transparente Preise und ein Ansprechpartner, der bis zum Abschluss des Projekts für Sie da ist.

Viele unserer Bilker Kunden kommen durch Empfehlung zu uns. Diese Mundpropaganda ist für uns das größte Kompliment und zeigt, dass unsere Arbeit überzeugt. Werden auch Sie Teil unserer zufriedenen Kundschaft!`
      },

      serviceHighlights: [
        {
          title: "Altbaurenovierung Bilk",
          description: "Spezialisiert auf die hohen Decken und Stuckelemente der Bilker Gründerzeitbauten.",
          link: "/renovierung-duesseldorf"
        },
        {
          title: "Wohnungsübergabe Bilk",
          description: "Schnell und zuverlässig für Mieter und Vermieter im Bilker Viertel.",
          link: "/wohnungsuebergabe-duesseldorf"
        },
        {
          title: "Innenanstrich Bilk",
          description: "Professionelles Streichen auch bei über 3,50 m Deckenhöhe.",
          link: "/innenanstrich-duesseldorf"
        }
      ],

      faq: [
        {
          question: "Kennen Sie sich mit Altbauten in Bilk aus?",
          answer: "Absolut! Die Gründerzeitarchitektur in Bilk ist unser Spezialgebiet. Wir haben umfangreiche Erfahrung mit hohen Decken, Stuckelementen und den typischen Herausforderungen dieser Bausubstanz. Ob denkmalgeschützt oder nicht – wir wissen, welche Techniken und Materialien zum Einsatz kommen müssen."
        },
        {
          question: "Wie lange dauert eine Wohnungsrenovierung in einer typischen Bilker Altbauwohnung?",
          answer: "Das hängt von der Größe und dem Umfang der Arbeiten ab. Eine 80-m²-Wohnung mit Streichen aller Wände und Decken ist in der Regel innerhalb von 3-5 Arbeitstagen fertig. Bei umfangreicheren Arbeiten wie Tapetenwechsel oder Lackierungen kann es entsprechend länger dauern. Wir geben Ihnen im Angebot eine realistische Zeitschätzung."
        },
        {
          question: "Arbeiten Sie auch in den Bilker Arkaden oder am Bilker Bahnhof?",
          answer: "Ja, wir sind im gesamten Stadtteil Bilk tätig – von den Arkaden über den Bahnhofsbereich bis zu den Wohnstraßen rund um die Florastraße. Auch Gewerbeobjekte in Bilk betreuen wir gerne."
        },
        {
          question: "Können Sie kurzfristig für eine Wohnungsübergabe in Bilk kommen?",
          answer: "Ja, für Wohnungsübergaben bieten wir einen Express-Service an. Oft können wir innerhalb weniger Tage starten. Rufen Sie uns an oder buchen Sie online einen Beratungstermin – wir finden eine Lösung!"
        }
      ],

      nearbyAreas: [
        { name: "Unterbilk", slug: "unterbilk" },
        { name: "Oberbilk", slug: "oberbilk" },
        { name: "Friedrichstadt", slug: "friedrichstadt" },
        { name: "Wersten", slug: "wersten" },
        { name: "Flehe", slug: "flehe" }
      ],

      meta: {
        title: "Maler Düsseldorf-Bilk | Altbausanierung & Renovierung | FarbWelt",
        description: "Ihr Maler in Düsseldorf-Bilk ✓ Altbau-Spezialist ✓ Wohnungsrenovierung ✓ Faire Preise. Erfahrung mit Gründerzeitbauten. Jetzt kostenlosen Termin buchen!",
        keywords: "Maler Bilk, Maler Düsseldorf-Bilk, Altbausanierung Bilk, Wohnung streichen Bilk, Renovierung Bilk"
      }
    },

    // District: Pempelfort
    pempelfort: {
      heroTitle: "Maler in Düsseldorf-Pempelfort – Qualität für Ihr Zuhause",
      heroSubtitle: "Professionelle Malerarbeiten im grünen Herzen Düsseldorfs. Wir verschönern Ihre Wohnung in einem der attraktivsten Stadtteile der Landeshauptstadt.",

      mainContent: {
        intro: `Pempelfort ist einer der begehrtesten Wohnlagen Düsseldorfs. Der Stadtteil nördlich der Innenstadt beeindruckt durch seine gründerzeitliche Architektur, die Nähe zum Nordpark und zur Rheinuferpromenade sowie seine exzellente Infrastruktur. Hier leben Familien, junge Berufstätige und Senioren in einem harmonischen Miteinander – und alle schätzen die hohe Lebensqualität dieses grünen Viertels.

Als erfahrener Malerbetrieb haben wir in Pempelfort bereits zahlreiche Projekte realisiert. Wir kennen die typischen Altbauten entlang der Nordstraße ebenso wie die moderneren Wohnkomplexe Richtung Golzheim. Diese Vielfalt der Bausubstanz erfordert unterschiedliche Herangehensweisen – und genau das ist unsere Stärke. Wir passen unsere Arbeit individuell an jedes Objekt an.`,

        localExpertise: `Pempelfort ist bekannt für seine gepflegten Altbauten mit hohen Decken, großen Fenstern und oft aufwendigen Stuckelementen. Viele dieser Gebäude wurden um 1900 errichtet und strahlen noch heute den Charme der Gründerzeit aus. Als Maler in diesem Viertel müssen wir nicht nur handwerklich erstklassig arbeiten, sondern auch ein Gespür für die architektonische Geschichte haben.

Die Straßen rund um den Frankenplatz, die Kaiserswerther Straße und den Zoopark gehören zu unseren regelmäßigen Einsatzgebieten. Wir wissen, welche Farbtöne die Stimmung dieser klassischen Räume unterstreichen und welche modernen Akzente harmonisch ergänzen. Unsere Kunden schätzen diese Beratungskompetenz, die über das reine Handwerk hinausgeht.`,

        services: `In Pempelfort bieten wir das volle Spektrum unserer Malerleistungen an. Der Innenanstrich ist dabei unsere häufigste Dienstleistung. Ob Sie eine einzelne Wand als Akzent streichen möchten oder die gesamte Wohnung renovieren wollen – wir setzen Ihre Vorstellungen präzise um. Bei der Farbauswahl beraten wir Sie gerne und bringen Muster mit, damit Sie die Wirkung in Ihren eigenen Räumen testen können.

Tapezierarbeiten sind in Pempelfort besonders beliebt. Die großzügigen Raumhöhen bieten ideale Voraussetzungen für elegante Vliestapeten oder klassische Mustertapeten. Wir verarbeiten alle Tapetenarten – von der praktischen Raufaser bis zur exklusiven Designertapete. Auch das fachgerechte Entfernen alter Tapeten gehört zu unserem Service.

Für die Altbauten in Pempelfort bieten wir spezielle Restaurierungsarbeiten an. Stuckdecken, Zierleisten und historische Türen können wir fachgerecht aufarbeiten und in neuem Glanz erstrahlen lassen. Diese Arbeiten erfordern besonderes Know-how, das wir über Jahre aufgebaut haben.`,

        process: `Unser Serviceprozess ist auf maximalen Kundenkomfort ausgelegt. Nach Ihrer Kontaktaufnahme vereinbaren wir zeitnah einen Besichtigungstermin bei Ihnen in Pempelfort. Bei diesem Termin nehmen wir uns ausreichend Zeit, um Ihre Wünsche zu verstehen, den Zustand der Räume zu erfassen und Ihnen erste Empfehlungen zu geben.

Innerhalb weniger Tage erhalten Sie dann Ihr individuelles Angebot. Wir schlüsseln alle Positionen detailliert auf, sodass Sie genau wissen, welche Leistungen enthalten sind. Unsere Preise sind Festpreise – Nachforderungen gibt es bei uns nicht.

Nach Ihrer Auftragserteilung stimmen wir den Arbeitsbeginn mit Ihnen ab. Wir achten auf pünktliches Erscheinen, sauberes Arbeiten und eine zügige, aber gründliche Ausführung. Nach Abschluss gehen wir gemeinsam durch die Räume und stellen sicher, dass alles zu Ihrer Zufriedenheit ist.`,

        whyUs: `Was macht uns zum idealen Partner für Ihr Malerprojekt in Pempelfort? Unsere Kombination aus handwerklicher Kompetenz, lokaler Erfahrung und kundenorientiertem Service. Wir verstehen die hohen Ansprüche der Pempelforter Bewohner an ihre Wohnumgebung und erfüllen diese mit Leidenschaft und Professionalität.

Unsere Referenzen in Pempelfort sprechen für sich. Von der kleinen Studentenwohnung bis zur großzügigen Familienwohnung, vom Ladenlokal bis zur Arztpraxis – wir haben in diesem Stadtteil alle Arten von Projekten erfolgreich umgesetzt. Vertrauen Sie auf unsere Erfahrung!`
      },

      serviceHighlights: [
        {
          title: "Altbaupflege Pempelfort",
          description: "Erhaltung und Restaurierung historischer Bauelemente in Gründerzeitgebäuden.",
          link: "/renovierung-duesseldorf"
        },
        {
          title: "Innenanstrich Pempelfort",
          description: "Hochwertige Wandgestaltung für die eleganten Altbauwohnungen des Viertels.",
          link: "/innenanstrich-duesseldorf"
        },
        {
          title: "Tapezieren Pempelfort",
          description: "Von klassisch bis modern – professionelle Tapezierarbeiten für jeden Geschmack.",
          link: "/tapezierarbeiten-duesseldorf"
        }
      ],

      faq: [
        {
          question: "Haben Sie Erfahrung mit den Altbauten in Pempelfort?",
          answer: "Ja, Pempelfort gehört zu unseren Haupteinsatzgebieten. Wir haben hier bereits viele Projekte in Gründerzeitbauten realisiert und kennen die typischen Herausforderungen – von hohen Decken über Stuckelemente bis zu historischen Holztüren."
        },
        {
          question: "Können Sie auch Stuckdecken restaurieren?",
          answer: "Ja, wir bieten Stuckrestaurierung als Spezialleistung an. Wir können beschädigte Stuckelemente ausbessern, fehlende Teile ergänzen und die gesamte Decke fachgerecht streichen. Auf Wunsch arbeiten wir auch mit Vergoldungen oder Patina-Effekten."
        },
        {
          question: "Wie hoch sind die Kosten für eine Renovierung in Pempelfort?",
          answer: "Das hängt vom Umfang der Arbeiten ab. Für einen groben Richtwert: Eine Standardrenovierung mit Streichen aller Wände und Decken kostet etwa 10-18€ pro m². Für ein präzises Angebot vereinbaren wir gerne einen kostenlosen Besichtigungstermin."
        },
        {
          question: "Arbeiten Sie auch am Wochenende in Pempelfort?",
          answer: "Unsere regulären Arbeitszeiten sind Montag bis Freitag. In Ausnahmefällen, etwa bei dringenden Terminen oder besonderen Kundenwünschen, können wir nach Absprache auch samstags arbeiten."
        }
      ],

      nearbyAreas: [
        { name: "Derendorf", slug: "derendorf" },
        { name: "Golzheim", slug: "golzheim" },
        { name: "Düsseltal", slug: "duesseltal" },
        { name: "Stadtmitte", slug: "stadtmitte" },
        { name: "Flingern Nord", slug: "flingern-nord" }
      ],

      meta: {
        title: "Maler Düsseldorf-Pempelfort | Altbau & Renovierung | FarbWelt",
        description: "Professioneller Maler in Pempelfort ✓ Altbau-Experte ✓ Stuckrestaurierung ✓ Hochwertige Malerarbeiten. Jetzt kostenlosen Beratungstermin buchen!",
        keywords: "Maler Pempelfort, Maler Düsseldorf-Pempelfort, Altbau Pempelfort, Renovierung Pempelfort, Stuckdecke restaurieren"
      }
    },

    // District: Oberkassel
    oberkassel: {
      heroTitle: "Maler in Düsseldorf-Oberkassel – Exzellenz für exklusive Lagen",
      heroSubtitle: "Premium-Malerarbeiten für eine der besten Adressen Düsseldorfs. Höchste Qualität für anspruchsvolle Kunden linksrheinisch.",

      mainContent: {
        intro: `Oberkassel ist die erste Adresse am linken Rheinufer – und das nicht ohne Grund. Der Stadtteil besticht durch seine villenähnlichen Altbauten, die ruhige Lage und den atemberaubenden Blick auf die Düsseldorfer Skyline. Wer in Oberkassel wohnt, schätzt Qualität, Stil und Exklusivität. Genau diese Ansprüche erfüllen wir mit unseren Malerleistungen.

Als Malerbetrieb mit Premium-Anspruch haben wir uns auf anspruchsvolle Projekte in gehobenen Wohnlagen spezialisiert. In Oberkassel haben wir bereits zahlreiche Villen, Penthäuser und großzügige Altbauwohnungen verschönert. Unsere Kunden erwarten erstklassige Qualität – und genau das liefern wir, bei jedem einzelnen Projekt.`,

        localExpertise: `Oberkassel unterscheidet sich von anderen Düsseldorfer Stadtteilen durch seine exklusive Bebauung. Die prächtigen Villen entlang der Luegallee, die repräsentativen Altbauten an der Belsenstraße und die modernen Architektur-Highlights am Rheinufer – jedes Objekt hat seinen eigenen Charakter und erfordert eine individuelle Herangehensweise.

Wir kennen die besonderen Anforderungen dieser Immobilien. Die großzügigen Raumhöhen von oft über 4 Metern, die aufwendigen Fassadendetails, die hochwertigen Materialien – all das erfordert spezielles Know-how und beste Ausrüstung. Unsere Maler sind erfahren im Umgang mit exklusiven Objekten und arbeiten mit der gebotenen Sorgfalt und Diskretion.`,

        services: `Unser Leistungsspektrum in Oberkassel umfasst alle Premium-Malerarbeiten. Beim Innenanstrich verwenden wir ausschließlich Premiumfarben führender Hersteller. Auf Wunsch setzen wir auch exklusive Wandveredelungstechniken ein – von Marmorino über Kalkputz bis hin zu Spachteltechniken, die einzigartige Oberflächeneffekte erzeugen.

Die Fassadenarbeiten in Oberkassel erfordern besondere Sorgfalt. Viele der historischen Villen verfügen über aufwendige Fassadenornamente, Stuckelemente und kunstvolle Details. Wir restaurieren und erhalten diese Elemente fachgerecht und setzen modernste Schutzsysteme ein, die den Originalcharakter bewahren.

Für Interior-Designer und Architekten bieten wir spezielle Kooperationen an. Wir setzen anspruchsvolle Farbkonzepte präzise um und arbeiten hand in Hand mit anderen Gewerken. Dabei halten wir höchste Standards bei Termintreue und Ausführungsqualität ein.`,

        process: `In Oberkassel legen wir besonderen Wert auf einen persönlichen, diskreten Service. Der Ersttermin findet selbstverständlich bei Ihnen statt – wir nehmen uns ausreichend Zeit für Ihre Wünsche und beraten Sie umfassend zu Materialien, Farben und Techniken. Auf Wunsch bringen wir Muster und Referenzfotos ähnlicher Projekte mit.

Unser Angebot erhalten Sie zeitnah in detaillierter Form. Wir erläutern jeden einzelnen Posten und beantworten Ihre Fragen transparent. Zusatzkosten oder unerwartete Nachforderungen gibt es bei uns nicht – der vereinbarte Preis gilt.

Während der Ausführung achten wir penibel auf Sauberkeit und Schutz Ihrer hochwertigen Einrichtung. Wir arbeiten zügig, aber niemals hastig – Qualität hat für uns oberste Priorität. Nach Abschluss besprechen wir das Ergebnis gemeinsam mit Ihnen und stellen sicher, dass jedes Detail Ihren Vorstellungen entspricht.`,

        whyUs: `Warum wählen anspruchsvolle Kunden in Oberkassel FarbWelt Service? Weil wir verstehen, was Exzellenz bedeutet. Unsere Mitarbeiter sind sorgfältig ausgewählt und speziell geschult für hochwertige Objekte. Wir verwenden nur erstklassige Materialien und modernste Techniken. Und wir liefern nicht nur gute Ergebnisse, sondern herausragende.

Diskretion ist für uns selbstverständlich. Wir behandeln jedes Projekt vertraulich und arbeiten so, dass Ihre Nachbarn nicht gestört werden. Unsere Fahrzeuge sind dezent beschriftet, unsere Mitarbeiter korrekt gekleidet und unser Auftreten ist professionell.`
      },

      serviceHighlights: [
        {
          title: "Premium-Innenanstrich",
          description: "Exklusive Wandgestaltung mit hochwertigen Materialien für anspruchsvolle Räume.",
          link: "/innenanstrich-duesseldorf"
        },
        {
          title: "Villen-Fassaden",
          description: "Fachgerechte Fassadensanierung für repräsentative Altbauvillen.",
          link: "/fassadenarbeiten-duesseldorf"
        },
        {
          title: "Spachteltechniken",
          description: "Marmorino, Kalkputz und andere edle Oberflächenveredelungen.",
          link: "/renovierung-duesseldorf"
        }
      ],

      faq: [
        {
          question: "Arbeiten Sie diskret in Oberkassel?",
          answer: "Absolut. Diskretion ist für uns in gehobenen Wohnlagen selbstverständlich. Unsere Mitarbeiter sind im professionellen Umgang mit anspruchsvollen Kunden geschult, unsere Fahrzeuge dezent beschriftet. Wir achten darauf, Nachbarn nicht zu stören und behandeln alle Projektdetails vertraulich."
        },
        {
          question: "Können Sie auch mit meinem Interior-Designer zusammenarbeiten?",
          answer: "Ja, gerne. Wir haben Erfahrung in der Zusammenarbeit mit Architekten und Interior-Designern und setzen deren Konzepte präzise um. Gemeinsame Abstimmungstermine und detaillierte Briefings gehören für uns zum Standard bei solchen Projekten."
        },
        {
          question: "Bieten Sie auch exklusive Wandtechniken an?",
          answer: "Ja, wir beherrschen verschiedene hochwertige Spachteltechniken wie Marmorino, Stucco Lustro und Kalkputz. Diese Veredelungstechniken verleihen Ihren Wänden eine einzigartige Tiefe und Eleganz. Gerne zeigen wir Ihnen Referenzen und Muster."
        },
        {
          question: "Was kostet Premium-Malerarbeit in Oberkassel?",
          answer: "Die Kosten variieren je nach Technik und Material erheblich. Hochwertige Wandveredelungen beginnen bei etwa 50€ pro m² und können bei exklusiven Techniken deutlich höher liegen. Für ein präzises Angebot vereinbaren wir gerne einen persönlichen Beratungstermin."
        }
      ],

      nearbyAreas: [
        { name: "Niederkassel", slug: "niederkassel" },
        { name: "Heerdt", slug: "heerdt" },
        { name: "Lörick", slug: "loerick" },
        { name: "Altstadt", slug: "altstadt" }
      ],

      meta: {
        title: "Maler Düsseldorf-Oberkassel | Premium Malerarbeiten | FarbWelt",
        description: "Exklusiver Maler in Oberkassel ✓ Premium-Qualität ✓ Villen & Penthäuser ✓ Diskret & professionell. Für anspruchsvolle Kunden linksrheinisch.",
        keywords: "Maler Oberkassel, Premium Maler Düsseldorf, Villen streichen, exklusive Malerarbeiten, Wandveredelung Oberkassel"
      }
    },

    // District: Flingern Nord
    flingernNord: {
      heroTitle: "Maler in Düsseldorf-Flingern Nord – Kreativ & Professionell",
      heroSubtitle: "Malerarbeiten im kreativen Herzen Düsseldorfs. Von der Altbauwohnung bis zum Loft – wir gestalten Ihre Räume individuell.",

      mainContent: {
        intro: `Flingern Nord hat sich in den letzten Jahren zu einem der angesagtesten Viertel Düsseldorfs entwickelt. Der ehemalige Arbeiterstadtteil besticht heute durch seinen kreativen Mix aus Galerien, Start-ups, Cafés und liebevoll sanierten Altbauten. Hier treffen sich junge Kreative, Familien und alteingesessene Düsseldorfer – und alle schätzen den besonderen Charme dieses lebendigen Viertels.

Als Malerbetrieb spiegeln wir diese Vielfalt in unserer Arbeit wider. Ob Sie einen klassischen weißen Anstrich für Ihre Altbauwohnung wünschen oder eine ausgefallene Farbgestaltung für Ihr Loft im umgebauten Industriegebäude suchen – wir setzen Ihre Ideen kreativ und professionell um.`,

        localExpertise: `Flingern Nord ist geprägt von seinem industriellen Erbe. Ehemalige Fabrikhallen wurden zu Lofts umgebaut, Hinterhöfe zu Ateliers transformiert, alte Werkstätten zu modernen Büros. Diese besondere Bausubstanz erfordert oft unkonventionelle Lösungen – und genau das reizt uns als Handwerker.

Wir kennen die Straßenzüge zwischen Ackerstraße und Birkenstraße, haben in den charakteristischen Backsteinbauten ebenso gearbeitet wie in den frisch sanierten Gründerzeitgebäuden. Diese lokale Erfahrung ermöglicht es uns, für jedes Objekt die passende Lösung zu finden – sei es bei der Farbauswahl, der Technik oder dem Material.`,

        services: `Unser Angebot in Flingern Nord ist so vielfältig wie das Viertel selbst. Der klassische Innenanstrich gehört ebenso dazu wie ausgefallene Wandgestaltungen mit Effektfarben, Schablonentechniken oder geometrischen Mustern. Für kreative Köpfe entwickeln wir gerne individuelle Farbkonzepte, die Ihrer Persönlichkeit und Ihrem Wohnstil entsprechen.

In den Lofts und umgebauten Industrieräumen Flingerns arbeiten wir oft mit besonderen Materialien. Sichtbeton, Ziegel und Stahlträger – diese industriellen Elemente können wir farblich integrieren oder bewusst kontrastieren. Auch große Wandflächen und hohe Decken schrecken uns nicht – wir verfügen über die nötige Ausrüstung und Erfahrung.

Für Gewerbekunden im Kreativviertel bieten wir spezielle Lösungen. Ob Büro, Galerie, Café oder Laden – wir gestalten Ihre Geschäftsräume so, dass sie zu Ihrer Marke passen und bei Kunden Eindruck hinterlassen.`,

        process: `In Flingern Nord gehen wir besonders kreativ an unsere Projekte heran. Beim Ersttermin sprechen wir nicht nur über praktische Aspekte, sondern auch über Ihren Stil, Ihre Vorlieben und die Atmosphäre, die Sie schaffen möchten. Wir verstehen uns als Partner, der Ihre Vision umsetzt – nicht nur als Handwerker, der Wände streicht.

Auf Wunsch erstellen wir Visualisierungen, zeigen Farbmuster in verschiedenen Lichtverhältnissen oder bringen Referenzfotos ähnlicher Projekte mit. So können Sie sich Ihr Ergebnis vorab vorstellen und eventuell noch Anpassungen vornehmen.

Die Ausführung erfolgt zuverlässig und termingerecht. Wir achten auf Sauberkeit, schützen Ihre Einrichtung professionell und hinterlassen die Räume besenrein. Bei kreativen Projekten dokumentieren wir gerne den Vorher-Nachher-Vergleich für Sie.`,

        whyUs: `Flingern Nord ist ein Viertel der kreativen Köpfe – und genau das sind wir auch. Wir lieben besondere Projekte, ausgefallene Ideen und individuelle Lösungen. Bei uns bekommen Sie nicht 08/15, sondern maßgeschneiderte Handwerkskunst.

Gleichzeitig sind wir Profis durch und durch. Kreativität bedeutet für uns nicht Chaos, sondern durchdachte Konzepte, zuverlässige Ausführung und faire Preise. Wir halten, was wir versprechen – das hat sich in Flingern herumgesprochen.`
      },

      serviceHighlights: [
        {
          title: "Loft-Gestaltung",
          description: "Kreative Farbkonzepte für umgebaute Industrieräume und offene Grundrisse.",
          link: "/renovierung-duesseldorf"
        },
        {
          title: "Effektmalerei",
          description: "Besondere Wandgestaltungen mit Strukturen, Mustern und Farbeffekten.",
          link: "/innenanstrich-duesseldorf"
        },
        {
          title: "Gewerberäume",
          description: "Professionelle Gestaltung von Büros, Galerien und Geschäften im Kreativviertel.",
          link: "/renovierung-duesseldorf"
        }
      ],

      faq: [
        {
          question: "Können Sie auch ausgefallene Farbwünsche umsetzen?",
          answer: "Absolut! Wir lieben kreative Projekte. Ob kräftige Farben, geometrische Muster, Ombré-Effekte oder individuelle Wandbilder – wir setzen Ihre Ideen professionell um. Bei der Farbauswahl beraten wir Sie gerne und zeigen Muster in verschiedenen Lichtverhältnissen."
        },
        {
          question: "Haben Sie Erfahrung mit Lofts und Industrieräumen?",
          answer: "Ja, die umgebauten Industriegebäude in Flingern Nord gehören zu unseren regelmäßigen Einsatzorten. Wir wissen, wie man mit Sichtbeton, Ziegelwänden und hohen Decken umgeht und wie man industriellen Charme mit modernem Wohnkomfort verbindet."
        },
        {
          question: "Bieten Sie auch Gewerbemalerei in Flingern an?",
          answer: "Ja, wir betreuen zahlreiche Gewerbekunden in Flingern Nord – von Cafés und Restaurants über Galerien bis zu Bürogemeinschaften. Wir arbeiten gerne auch außerhalb der Öffnungszeiten, um Ihren Betrieb nicht zu stören."
        },
        {
          question: "Wie finde ich die richtige Wandfarbe für mein Loft?",
          answer: "Wir beraten Sie gerne! Bei einem Vor-Ort-Termin analysieren wir die Lichtverhältnisse, die vorhandene Einrichtung und Ihren persönlichen Stil. Anschließend schlagen wir passende Farben vor und bringen Muster mit, damit Sie die Wirkung live sehen können."
        }
      ],

      nearbyAreas: [
        { name: "Flingern Süd", slug: "flingern-sued" },
        { name: "Düsseltal", slug: "duesseltal" },
        { name: "Oberbilk", slug: "oberbilk" },
        { name: "Stadtmitte", slug: "stadtmitte" }
      ],

      meta: {
        title: "Maler Düsseldorf-Flingern Nord | Kreativ & Professionell | FarbWelt",
        description: "Ihr Maler in Flingern Nord ✓ Loft-Gestaltung ✓ Kreative Wandkonzepte ✓ Gewerbemalerei. Individuelle Malerarbeiten im Kreativviertel!",
        keywords: "Maler Flingern Nord, Loft streichen Düsseldorf, kreative Wandgestaltung, Maler Kreativviertel Düsseldorf"
      }
    },

    // District: Derendorf
    derendorf: {
      heroTitle: "Maler in Düsseldorf-Derendorf – Zuverlässig & Kompetent",
      heroSubtitle: "Professionelle Malerarbeiten im aufstrebenden Derendorf. Wir verschönern Wohnungen, Büros und Geschäftsräume zwischen Golzheimer Heide und Frankenplatz.",

      mainContent: {
        intro: `Derendorf ist ein Stadtteil im Wandel. Das Viertel nördlich der Innenstadt entwickelt sich rasant – neue Wohnanlagen entstehen, alte Industrieflächen werden zu attraktiven Quartieren umgewandelt, und immer mehr Menschen entdecken die Vorzüge dieser zentralen Lage. Die Nähe zum Hauptbahnhof, die gute Infrastruktur und die Mischung aus Alt und Neu machen Derendorf zu einer begehrten Adresse.

Wir begleiten diese Entwicklung als Malerbetrieb vor Ort. Ob Neubau oder Altbausanierung, Privatwohnung oder Gewerbefläche – wir sind der richtige Partner für alle Malerarbeiten in Derendorf. Unsere Kunden schätzen unsere Zuverlässigkeit, unser Know-how und unsere fairen Preise.`,

        localExpertise: `Derendorf ist vielfältig: Im Süden grenzt es an das elegante Pempelfort, im Norden an Golzheim mit seiner gehobenen Wohnlage. Dazwischen finden sich Gründerzeitbauten, Nachkriegsarchitektur und moderne Neubauten. Diese Mischung erfordert einen Malerbetrieb, der sich auf unterschiedlichste Bausubstanzen einstellt.

Wir kennen Derendorf aus langjähriger Erfahrung. Die Wohnstraßen rund um den Rather Broich, die Gewerbeflächen am Derendorfer Dreieck, die neuen Quartiere am ehemaligen Güterbahnhof – überall haben wir bereits gearbeitet und Kunden zufriedengestellt.`,

        services: `Unser Leistungsspektrum deckt alle typischen Anforderungen in Derendorf ab. Für Wohnungen bieten wir den kompletten Renovierungsservice: Wände und Decken streichen, Tapezieren, Lackieren von Türen und Heizkörpern. Bei Neubauten übernehmen wir die Erstbeschichtung mit hochwertigen, wohngesunden Farben.

Im Gewerbebereich sind wir ebenfalls stark vertreten. Büros, Praxen, Geschäfte – wir gestalten Ihre Räume professionell und termingerecht. Dabei arbeiten wir bei Bedarf auch außerhalb der Geschäftszeiten, um Ihren Betrieb nicht zu stören.

Fassadenarbeiten gehören ebenso zu unserem Angebot. Ob Anstrich, Ausbesserung oder komplette Sanierung – wir bringen Ihre Fassade in einen gepflegten Zustand und schützen sie langfristig vor Witterungseinflüssen.`,

        process: `Jedes Projekt beginnt mit einem persönlichen Gespräch. Bei einem Vor-Ort-Termin in Derendorf erfassen wir die Gegebenheiten, besprechen Ihre Wünsche und erstellen anschließend ein detailliertes Angebot. Dieser Service ist selbstverständlich kostenlos und unverbindlich.

Unser Angebot enthält alle relevanten Positionen transparent aufgelistet. Sie wissen genau, was enthalten ist und was es kostet. Nachforderungen oder versteckte Kosten gibt es bei uns nicht.

Nach Auftragserteilung starten wir zum vereinbarten Termin. Wir achten auf pünktliches Erscheinen, sauberes Arbeiten und eine zügige Fertigstellung. Am Ende nehmen wir gemeinsam die Arbeit ab und stellen sicher, dass Sie rundum zufrieden sind.`,

        whyUs: `Warum FarbWelt Service in Derendorf? Weil wir solide Handwerksarbeit zu fairen Preisen liefern. Keine überzogenen Versprechungen, keine bösen Überraschungen – stattdessen zuverlässige Qualität, auf die Sie sich verlassen können.

Unsere Stärke ist die Kombination aus Erfahrung und Flexibilität. Wir haben schon viele verschiedene Projekte in Derendorf umgesetzt und finden für jede Anforderung die passende Lösung. Dabei bleiben wir preislich im Rahmen und halten unsere Termine ein.`
      },

      serviceHighlights: [
        {
          title: "Wohnungsrenovierung",
          description: "Komplettrenovierung für Alt- und Neubauwohnungen in Derendorf.",
          link: "/renovierung-duesseldorf"
        },
        {
          title: "Gewerbemalerei",
          description: "Professionelle Gestaltung von Büros, Praxen und Geschäften.",
          link: "/renovierung-duesseldorf"
        },
        {
          title: "Fassadenanstrich",
          description: "Schutz und Verschönerung für Fassaden in Derendorf.",
          link: "/fassadenarbeiten-duesseldorf"
        }
      ],

      faq: [
        {
          question: "Arbeiten Sie auch in den Neubauten in Derendorf?",
          answer: "Ja, wir betreuen sowohl Alt- als auch Neubauten. In den neuen Wohnquartieren in Derendorf haben wir bereits zahlreiche Erstbezüge mit Malerarbeiten ausgestattet. Wir kennen die Anforderungen moderner Bausubstanz und verwenden entsprechend geeignete Materialien."
        },
        {
          question: "Können Sie auch Gewerberäume in Derendorf streichen?",
          answer: "Ja, Gewerbemalerei gehört zu unseren Kernleistungen. Wir arbeiten bei Bedarf auch am Wochenende oder abends, um Ihren Geschäftsbetrieb nicht zu stören. Von Büros über Arztpraxen bis zu Ladenlokalen – wir gestalten alle Arten von Gewerberäumen."
        },
        {
          question: "Wie schnell können Sie in Derendorf starten?",
          answer: "In der Regel können wir innerhalb von 1-2 Wochen mit den Arbeiten beginnen. Bei dringenden Projekten wie Wohnungsübergaben bemühen wir uns um schnellere Termine. Kontaktieren Sie uns einfach mit Ihrem Wunschtermin."
        },
        {
          question: "Bieten Sie Festpreise für Projekte in Derendorf?",
          answer: "Ja, wir arbeiten grundsätzlich mit Festpreisen. Nach einer Vor-Ort-Besichtigung erhalten Sie ein verbindliches Angebot ohne versteckte Kosten. Der genannte Preis gilt, auch wenn die Arbeiten länger dauern sollten."
        }
      ],

      nearbyAreas: [
        { name: "Pempelfort", slug: "pempelfort" },
        { name: "Golzheim", slug: "golzheim" },
        { name: "Mörsenbroich", slug: "moersenbroich" },
        { name: "Düsseltal", slug: "duesseltal" }
      ],

      meta: {
        title: "Maler Düsseldorf-Derendorf | Wohnung & Gewerbe | FarbWelt Service",
        description: "Zuverlässiger Maler in Derendorf ✓ Wohnungsrenovierung ✓ Gewerbemalerei ✓ Fassaden. Faire Festpreise für Alt- und Neubau!",
        keywords: "Maler Derendorf, Maler Düsseldorf-Derendorf, Renovierung Derendorf, Gewerbemalerei Derendorf"
      }
    }
  }
};

// Import additional content files
import { seoContentDuesseldorf2 } from './seoContentDuesseldorf2';
import { seoContentDuesseldorf3 } from './seoContentDuesseldorf3';
import { seoContentDuesseldorf4 } from './seoContentDuesseldorf4';
import { seoContentDuesseldorf5 } from './seoContentDuesseldorf5';
import { seoContentDormagen } from './seoContentDormagen';
import seoContentKoeln from './seoContentKoeln';
import seoContentKoeln2 from './seoContentKoeln2';
import seoContentKoeln3 from './seoContentKoeln3';
import seoContentLeverkusen from './seoContentLeverkusen';
import seoContentMonheim from './seoContentMonheim';

// Merge all Düsseldorf district content
Object.assign(seoContent.duesseldorf, seoContentDuesseldorf2, seoContentDuesseldorf3, seoContentDuesseldorf4, seoContentDuesseldorf5);

// Add Dormagen content
seoContent.dormagen = seoContentDormagen;

// Add Köln content
seoContent.koeln = { ...seoContentKoeln, ...seoContentKoeln2, ...seoContentKoeln3 };

// Add Leverkusen content
seoContent.leverkusen = seoContentLeverkusen;

// Add Monheim content
seoContent.monheim = seoContentMonheim;

// Helper to get content for a specific location
export const getLocationContent = (citySlug, districtSlug = null) => {
  const cityContent = seoContent[citySlug];
  if (!cityContent) return null;
  
  if (districtSlug) {
    // First try with the original slug (e.g., "neustadt-nord")
    if (cityContent[districtSlug]) {
      return cityContent[districtSlug];
    }
    // Then try converting slug to camelCase (e.g., "flingern-nord" -> "flingernNord")
    const camelKey = districtSlug.replace(/-([a-z])/g, (g) => g[1].toUpperCase());
    return cityContent[camelKey] || null;
  }
  
  return cityContent.main || null;
};

export default seoContent;
